import React from 'react';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';  // Asegúrate de importar StandardFonts
import { toast } from 'react-toastify';
import { saveAs } from 'file-saver';  // Importa la librería file-saver

// Función para firmar el PDF
const FirmarPdf = async (userData, fechaAprobado) => {
  // Paso 1: Cargar el archivo PDF
  const pdfUrl = '/stylesheet/documents/CertificadoCursoVirtualMotociclista.pdf';  // Ruta al archivo en la carpeta public/stylesheet/documents
  const pdfBytes = await fetch(pdfUrl).then(res => res.arrayBuffer());

  // Paso 2: Cargar el documento PDF con pdf-lib
  const pdfDoc = await PDFDocument.load(pdfBytes);

  // Paso 3: Obtener la primera página (puedes modificar otras páginas también)
  const pages = pdfDoc.getPages();
  const firstPage = pages[0];

  // Paso 4: Seleccionar la fuente y el texto a agregar
  const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  // Obtener los datos del usuario pasados como props
  const { nombres, apellidos, documento } = userData;

  const nombreArchivo = `CertificadoCursoVirtualMotociclista_${documento}`;

  // Paso 5: Dibujar el texto en el PDF (especificamos la posición)
  firstPage.drawText(`${nombres} ${apellidos}`, {
    x: 250,  // Coordenada X
    y: 335,  // Coordenada Y
    size: 20,  // Tamaño de la fuente
    font: fontBold,
    color: rgb(0, 0, 0), // Color del texto (negro)
  });

  firstPage.drawText(documento, {
    x: 400,
    y: 310,
    size: 18,
    font: fontBold,
    color: rgb(0, 0, 0), // Color del texto (negro)
  });

  // Convertir la cadena a un objeto Date
  const fechaObj = new Date(fechaAprobado);

  // Extraer día, mes y año
  const opcionesFormato = { day: 'numeric', month: 'long', year: 'numeric' };
  const fechaFormateada = fechaObj.toLocaleDateString('es-ES', opcionesFormato);

  // Reorganizar los elementos al formato deseado
  const partesFecha = fechaFormateada.split(' de ');
  const mesConMayuscula = partesFecha[1].charAt(0).toUpperCase() + partesFecha[1].slice(1);
  const fechaPersonalizada = `${mesConMayuscula} ${partesFecha[0]} de ${partesFecha[2]}`;

  firstPage.drawText(fechaPersonalizada, {
    x: 320,
    y: 100,
    size: 12,
    font: font,
    color: rgb(0, 0, 0)  // Negro
  });


  // Paso 6: Guardar el PDF con los datos agregados
  const pdfBytesConFirma = await pdfDoc.save();

  try {
    // Crear un blob con los bytes del PDF modificado
    const pdfBlob = new Blob([pdfBytesConFirma], { type: 'application/pdf' });

    // Usar la librería file-saver para guardar el archivo en el dispositivo del usuario
    saveAs(pdfBlob, nombreArchivo);

    // Si la descarga es exitosa
    toast.success(`¡Archivo descargado con éxito!`, {
      position: "bottom-right",
      autoClose: 1500,
    });
  } catch (error) {
    console.error(error);
    toast.error("Hubo un error al descargar el archivo.", {
      position: "bottom-right",
      autoClose: 1500,
    });
  }
};

export default FirmarPdf;
